<template>

  <div style="height: 100%; margin-bottom:-64px;">

    <HelloWorld style="margin-top:-96px;" />

    <div id="midNav" style="height: 96px;" class="hidden-sm-and-down">
      <v-toolbar :class="{'elevation-1':scrolled, 'elevation-0':!scrolled, 'fixMe':scrolled}"  dark>

        <template v-slot:extension>

          <v-toolbar-items  style="position:absolute;right:0;left:0;top:0px;">

            <v-container flex grid-list-sm class="pa-0" >

              <v-layout
                wrap
              >

                <v-flex xs12 md10 xl8 offset-md1 offset-xl2>

                  <v-container  class="pa-0" style="max-width: none;">
                    <v-layout >
                      <v-flex :style="{'flex':  maxWidth + ' 1 auto', 'opacity': thisOpacity}" style="overflow: hidden;">

                        <v-btn :style="{'padding-left':  thisPadding + 'px', 'padding-right':  thisPadding + 'px'}" class="ma-0 big-icon-btn" style="overflow: hidden; width: 100%; height: 96px; min-width: 0;" dark depressed  to="/#lisa" @click="gotoLISA()">
                          <i aria-hidden="true" class="v-icon mdi theme--dark" style="font-size: 36px;">
                            <v-img style="    top: -44px;     width: 52px;
    height: 52px; position: absolute; min-height: 100%;"
                                   :src="require('@/assets/lisa.svg')"
                                   aspect-ratio="1"
                                   alt="ESA"
                                   height="100%"
                            ></v-img>
                          </i>

                          <span :style="{'font-size': thisFont + 'px'}" style="height:48px; line-height: 48px;" class="mb-2">LISA</span></v-btn>

                      </v-flex>
                      <v-flex>

                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="#mission" @click="gotoMission()">
                          <v-icon large  dark>mdi-rocket</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Mission</span></v-btn>

                      </v-flex>
                      <v-flex>

                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="#science" @click="gotoScience()">
                          <v-icon large  dark>mdi-star</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Science</span></v-btn>

                      </v-flex>
                      <v-flex>
                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="#tech" @click="gotoTech()">
                          <v-icon large  dark>mdi-hexagon-multiple</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Tech</span></v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="#data" @click="gotoData()">
                          <v-icon large  dark>mdi-database</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Data</span></v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/team">
                          <v-icon large  dark>mdi-account-group</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Team</span></v-btn>
                      </v-flex>
                      <v-flex >

                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/gallery">
                          <v-icon large  dark>mdi-image-filter</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Gallery</span></v-btn>

                      </v-flex>

                      <v-flex>
                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/news">
                          <v-icon large  dark>mdi-calendar</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">News</span></v-btn>
                      </v-flex>
                      <v-flex >

                        <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed to="/contact">
                          <v-icon large  dark>mdi-email-outline</v-icon>
                          <span style="height:48px; line-height: 48px;" class="mb-2">Contact</span></v-btn>

                      </v-flex>

                    </v-layout>
                  </v-container>

                </v-flex>

              </v-layout>

            </v-container>

          </v-toolbar-items>
        </template>

      </v-toolbar>
    </div>

    <v-container flex grid-list-xl  class="pb-0">

      <v-layout
        text-xs-center
        wrap
      >

        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3">

          <v-layout
            text-xs-left
            wrap
          >

            <v-flex xs12>

              <v-layout
                text-xs-left
                wrap
              >

                <v-flex id="lisa" xs12 md8>
                  <div class="title ml-3 mb-3">News</div>
                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">
                    <v-card-text>
                      <div class="font-weight-light text-capitalize ">Jul 26, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Dead Stars Found Whipping Around Each Other in Minutes</div>
                      <div class="body-1 lineclamp">Two dead stars have been spotted whipping around each other every seven minutes. The rare celestial find was made using Caltech's Zwicky Transient Facility (ZTF), a state-of-the-art sky survey at Palomar Observatory that rapidly scans the night skies looking for anything that moves, blinks, or otherwise varies in brightness.</div>
                      <div class="font-weight-light text-capitalize pt-3">Jul 08, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Discovering exoplanets with gravitational waves</div>
                      <div class="body-1 lineclamp">In a recent paper in Nature Astronomy, researchers from the Max Planck Institute for Gravitational Physics (Albert Einstein Institute/AEI) in Potsdam and from the French Alternative Energies and Atomic Energy Commission (CEA) in Saclay, Paris suggest how the planned space-based gravitational-wave observatory LISA can detect exoplanets orbiting white dwarf binaries everywhere in our Milky Way and in the nearby Magellanic Clouds. This new method will overcome certain limitations of current electromagnetic detection techniques and might allow LISA to detect planets down to 50 Earth masses.</div>
                      <div class="font-weight-light text-capitalize pt-3">May 23, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">ESA: A unique experiment to explore black holes</div>
                      <div class="body-1 lineclamp">What happens when two supermassive black holes collide? Combining the observing power of two future ESA missions, Athena and LISA, would allow us to study these cosmic clashes and their mysterious aftermath for the first time.</div>
                      <v-btn  class="ml-0 mr-0 mt-3 mb-0" dark outline="" color="grey darken-1">More News</v-btn>
                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex xs12 md4>

                  <div class="title ml-3 mb-3">Milestones</div>

                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">

                    <v-timeline
                      align-top
                      dense
                    >
                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex xs3>
                            <strong>October 2019</strong>
                          </v-flex>
                          <v-flex>
                            <strong>Important Meeting</strong>
                            <div class="caption">ESA</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout wrap pt-3>
                          <v-flex xs3>
                            <strong>January 2020</strong>
                          </v-flex>
                          <v-flex>
                            <strong>Important meeting</strong>
                            <div class="caption mb-2">NASA</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex xs3>
                            <strong>August 2026</strong>
                          </v-flex>
                          <v-flex>
                            <strong>Lunch break</strong>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex xs3>
                            <strong>April 16, 2034</strong>
                          </v-flex>
                          <v-flex>
                            <strong>Launch</strong>
                            <div class="caption">Ariane 6</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>
                    </v-timeline>

                  </v-card>

                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>

    </v-container>

    <BigHeader id='mission' class="mt-5" title="The Mission" subtitle="LISA, the Laser Interferometer Space Antenna, will be a space-borne Gravitational Wave Observatory with an arm-length of 2.5 million km, compared to the few km's of the ground-based observatories. LISA will observe the entire universe and discover parts that are invisible by other means. It will enhance our knowledge about the beginning, evolution and structure of our universe. LISA will complement earth-bound gravitational wave and other astronomical observatories, and significantly enrich Multimessenger astronomy. LISA´s core technologies were already successfully tested with the LISA Pathfinder mission. Now, an international consortium of scientists together with ESA and NASA is working towards LISA´s launch." icon1="mdi-rocket" line1="Three spacecraft, 2.5 million km apart" icon2="mdi-white-balance-sunny"  line2="Heliocentric orbit, triangular formation" icon3="mdi-calendar"  line3="Launch date: 2034 (Ariane 6)"></BigHeader>

    <Content :boxes="mission" version="vertical"/>

    <BigHeader id='science'  title="Science Goals" subtitle="What powered the Big Bang, what happens to space and time in black holes and what is the mysterious dark energy accelerating the expansion of the Universe? LISA will be the first observatory in space to answer these questions that have been asking for a long time. As gravitational waves propagate unhindered through all regions of time and space, LISA will provide rich new information about the behaviour, structure and history of the universe, and about physics itself." icon1="mdi-transition-masked" line1="Galactic Compact Binary Stars" icon2="mdi-cryengine"  line2="Supermassive Black Hole Mergers" icon3="mdi-google-circles"  line3="Extreme Mass Ratio Inspirals"></BigHeader>

    <Content :boxes="science" version="vertical"/>

    <BigHeader id='tech' title="Technologies" subtitle="Gravitational waves are moving gravitational fields, “ripples” in the curvature of space-time, creating a time-varying strain or stretching of space-time. This appears as a fractional change in the distance between two points. Hence, LISA´s three spacecraft flying freely in space will oscillate together and apart by tiny amounts as a gravitational wave passes by. LISA will look for ripples with periods of a few minutes to a few hours. The expected distance changes are tiny, a few parts in 1021 or 1022 of the separation of the spacecraft." icon1="mdi-rocket" line1="Lorem Ipsum" icon2="mdi-white-balance-sunny"  line2="Lorem Ipsum" icon3="mdi-calendar"  line3="Lorem Ipsum"></BigHeader>

    <Content :boxes="tech" version="vertical"/>

    <BigHeader id='data' title="Data Analysis" subtitle="LISA leads to new methods and tools in data analysis because LISA data analysis experts face two central challenges: On one hand they have to ensure that the LISA instrument will be able to deliver data relevant for scientific questions. On the other hand they have to implement new techniques and concepts for extracting source parameters from the data streams." icon1="mdi-rocket" line1="Lorem Ipsum" icon2="mdi-white-balance-sunny"  line2="Lorem Ipsum" icon3="mdi-calendar"  line3="Lorem Ipsum"></BigHeader>

    <Content :boxes="data" class="mb-5" version="vertical"/>



  </div>

</template>

<script>
  import HelloWorld from '../components/HelloWorld'
  import Content from '../components/Content'
  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      HelloWorld,
      Content,
      BigHeader
    },
    data () {
      return {
        autoChange: false,
        autoScroll: true,
        elementData: 0,
        elementTop: 0,
        scrollTop: 0,
        maxWidth: 0,
        thisPadding: 0,
        thisFont: 0,
        thisOpacity: 0,
        scrolled: false,
        mission: [
          {
            title: 'A gravitational wave observatory',
            cat: 'LISA Mission',
            pages: [
              {
                title: 'The First Gravitational Wave Observatory in Space',
                image: 'laserbeam.jpg',
                text: 'With the first direct detection of gravitational waves in 2015, the era of gravitational wave astronomy has begun. But on Earth, observations are limited to objects with masses a few 10\'s that of the Sun, which produce high-frequency signals. Sources with much larger masses, such as the mergers of massive black holes at the centres of galaxies, produce signals at much lower frequencies, undetectable on Earth. LISA will detect such signals and will deliver exciting new science. It will allow us unique insights in our universe – its beginning and evolution, its population, maybe the big bang and so far unknown components.',
              },
              {
                title: 'Mission Concept',
                image: 'concept.jpg',
                text: 'The LISA mission consists of three spacecraft orbiting the Sun in a triangular configuration, connected by three arms of a laser interferometer. The three satellites, separated by millions of km, will form a high precision interferometer that senses gravitational waves by monitoring the minute changes in distance between free falling test masses inside the spacecraft. LISA will be an astronomical observatory of unprecedented versatility and range.',
              },
              {
                title: 'LISA Pathfinder´s heritage',
                image: 'dragfree.png',
                text: 'In 2016 and 2017 LISA´s core technologies were successfully tested with the LISA Pathfinder mission and already inspired other projects. Currently the Laser Ranging Instrument developed for LISA and tested on LISA Pathfinder flies on the GRACE Follow-On mission that observes the Earth´s water movements across the planet.',
              }
            ]
          },
          {
            title: 'Ripples in space-time',
            cat: 'LISA Mission',
            pages: [
              {
                title: 'Gravity is the dominant force in the universe',
                image: 'gwdifferent.jpg',
                text: 'Gravity is the engine behind the universe’s processes, and much of its action is dark. ' +
                  'This is why we want to measure gravity´s messengers: gravitational waves. They are ripples in the fabric of space-time, which travel undisturbed through the universe and provide us with revolutionary information about the so far dark universe. LISA will be the first ever mission studying the entire universe with gravitational waves. It will listen to gravity and let us go further than any alternative.',
              },
              {
                title: 'LISA will be a milestone for Multimessenger astronomy',
                image: 'spacevsground.jpg',
                text: 'Gravitational waves are fundamentally different from electromagnetic waves. This is why LISA will perfectly complement traditional astronomical observations based on the electromagnetic spectrum for example, observations from visible light, infrared or x-rays. LISA will open the gravitational wave window in space and measure gravitational radiation over a broad band of frequencies.',
              },
              {
                title: 'New technology: LISA will consist of sciencecrafts',
                text: 'The classical distinction between spacecraft and payload doesn’t fit LISA well, because the LISA spacecraft are not just providing the infrastructure for the instruments. Each LISA spacecraft is part of the instrument itself because it protects its key elements, the free-falling test masses, from disturbances. The LISA spacecraft must thus be designed and built with the gravitational requirements of the test masses in mind. The importance of the co-design and the co-operation of spacecraft and payload is captured in the term “sciencecraft”.',
              }
            ]
          },
          {
            title: 'In orbit around the Sun',
            cat: 'LISA Mission',
            pages: [
              {
                title: 'Measuring gravitational waves in space',
                image: 'how.jpg',
                text: 'Electromagnetic waves are created by the acceleration of electrical charges. Gravitational waves in contrast are moving gravitational fields, ripples in the curvature of space-time, generated by the acceleration of massive objects. They create a stretching and squeezing of space-time, which appear as tiny changes in the distance between two objects. With its high precision measurement system, LISA will observe a passing gravitational wave directly by measuring these changes of distance between two freely falling proof masses inside spacecraft.',
              },
              {
                title: 'Only in space: The long-baseline interferometer',
                text: 'LISA is so valuable for astronomers all over the world because it will measure low-frequency gravitational waves that cannot be observed from earth. The ideal instrument for this is a laser interferometer with an arm length as large as possible and long integration times. Hence LISA can be thought of as a high precision Michelson interferometer in space with an arm length of 2.5 mil¬lion km. The arm length has been carefully chosen to allow observation of most of the interesting sources of gravitational waves in the target frequency band.',
              },
              {
                title: 'LISA´s key features and sensivitiy',
                text: 'Key features of LISA are interferometric measurement of distances, long baselines of 2.5 x 106 km, drag free spacecraft based on inertial sensors, and the familiar “cartwheel”-orbits. Compared to the Earth-bound gravitational wave observatories LISA addresses the much richer frequency range between 0.1 mHz and 1 Hz, which is inaccessible on Earth due to armlength limitations and terrestrial gravity gradient noise. LISA will be an astronomical observatory of unprecedented versatility and range.',
              }
            ]
          },
          {
            title: 'A massive international team',
            cat: 'LISA Mission',
            pages: [
              {
                title: 'Who is behind LISA?',
                image: 'how.jpg',
                text: 'LISA is a truly international mission. More than 1,200 scientists from all over the world together with members from ESA, NASA and the national space agencies are working on realising the mission. The LISA mission is led by ESA with significant contributions from NASA. The LISA Consortium, the international collaboration of scientists, is working on all aspects of the mission including an instrument group charged with coordinating and delivering the LISA instruments to ESA.',
              },
              {
                title: 'Who is the LISA Consortium?',
                text: 'The LISA Consortium represents the European states involved in LISA - Germany, Italy, France, UK, Switzerland, Spain, Denmark, The Netherlands, Belgium, Portugal, Sweden, Hungary, Romania - and the USA. Besides preparing the science and the technology for the LISA mission, the consortium has strongly supported ESA\'s LISA Pathfinder mission (LPF). LPF has successfully demonstrated key technologies for LISA, paving also the way for next-generation Earth and planetary gravimetry.',
              },
              {
                title: 'The space agencies',
                text: 'ESA, the involved national space agencies in Europe and NASA provide the expertise and environment a space mission needs to come true. While the mission is led by ESA, NASA supports ESA and the LISA Consortium as a collaborative partner.',
              }
            ]
          },
          {
            title: 'On time for 2034',
            cat: 'LISA Mission',
            pages: [
              {
                title: 'When will LISA launch?',
                image: 'how.jpg',
                text: 'LISA is supposed to launch in 2034. Currently ...',
              },
              {
                title: 'Lorem Ipsum',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              },
              {
                title: 'Lorem Ipsum',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              }
            ]
          },
        ],
        science: [
          {
            title: 'A treasure trove of knowledge',
            cat: 'LISA Science Goals',
            pages: [
              {
                title: 'What will we learn from the Gravitational Universe?',
                image: 'laserbeam.jpg',
                text: 'Gravitational waves are ripples in the fabric of space-time generated by some of the most powerful astrophysical events - such as exploding stars and collisions of two black holes at the centres of galaxies. Gravitational waves travel at the speed of light through the universe, unhindered by intervening mass - to gravitational waves the universe is transparent. That is why gravitational waves are the cosmic messengers that allow us to explore the so far dark side of the universe.',
              },
              {
                title: 'What makes the Gravitational Universe so exciting?',
                image: 'concept.jpg',
                text: 'The Gravitational Universe will open a new window in astronomy using powerful sources of gravitational waves to probe a universe that cannot be probed by other means. Significant advances were made, by using our first sense for observing the universe, electromagnetic radiation. But most of the universe remains electromagnetically dark because on astronomical scales gravitation is the real engine of the universe. LISA will provide us with a new sense for observing the so far dark universe. It will let us listen to gravity and thus let us go further than any alternative.',
              },
              {
                title: 'How do we know what the signals look like?',
                image: 'dragfree.png',
                text: 'Each gravitational wave source emits characteristic gravitational wave signals – like fingerprints in waveform. Gravitational wave researchers are experts in precisely calculating the expected waveforms. They model the expected fingerprints using existing and developing new theoretical, analytic and numerical methods. The more accurately the waveform can be described, the more can be learned from the data once LISA is flying.',
              }
            ]
          },
          {
            title: 'Measurement signals',
            cat: 'LISA Science Goals',
            pages: [
              {
                title: 'What will LISA measure?',
                image: 'gwdifferent.jpg',
                text: 'LISA will observe the entire Universe and measure gravitational waves at very low frequencies with wavelengths, larger than the Earth itself. In this frequency band, from about 0.1 mHz to 100 mHz, the Universe is richly populated by strong sources of gravitational waves. LISA will provide the closest ever view of the early processes at TeV energies and can probe the entire universe from its smallest scales around singularities and black holes all the way to cosmological dimensions.',
              },
              {
                title: 'What can we learn from the observed signals?',
                image: 'spacevsground.jpg',
                text: 'LISA can avoid the noise from Earth and access regions of the spectrum that are inaccessible from Earth due to its extremely long arms. The gravitational wave sources that LISA will discover include ultra-compact binaries in our Galaxy, supermassive black hole mergers, and extreme mass ratio inspirals, among other exotic possibilities. With LISA we will listen for the first time to the low-frequency sound of the universe.',
              },
              {
                title: 'Why do we need a detector in space?',
                text: 'The gravitational wave spectrum covers a broad span of frequencies. While ground-based observatories give us access to the high-frequency regime of Gravitational Wave astronomy from 10 Hz to 1000 Hz, LISA will operate in the low frequency range, between 0.1 mHz and 1 Hz. This means the waves LISA is looking for have a much longer wavelength, corresponding to objects in much wider orbits and potentially much heavier than those that earth-bound detectors are searching for.',
              }
            ]
          },
          {
            title: 'Combined forces',
            cat: 'LISA Science Goals',
            pages: [
              {
                title: 'Multimessenger Astronomy',
                image: 'how.jpg',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              },
              {
                title: 'How does LISA help other astronomical observations?',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              },
              {
                title: 'Overview of astronomical methods',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              }
            ]
          },

        ],
        tech: [
          {
            title: 'Design features',
            cat: 'LISA Technology',
            pages: [
              {
                title: 'What is a suitable instrument for measuring gravitational waves in space?',
                image: 'laserbeam.jpg',
                text: 'A suitable instrument for measuring gravitational waves over a broad band of low frequencies is a laser interferometer with an arm length as large as possible and long integration times, the primary impetus for a space-borne detector. Hence LISA can be thought of basically as a high precision Michelson interferometer in space with an arm length of 2.5 million km. ',
              },
              {
                title: 'In three orbits around the sun',
                image: 'concept.jpg',
                text: 'LISA will consist of three spacecraft in Earth-like orbits around the Sun. They will fly 2.5 million kilometres apart in an equilateral triangle formation. The spacecraft will maintain their triangular formation even though they are in separate orbits around the Sun. The changing orientation of the triangle through one orbit will allow observers to determine the direction of gravitational wave sources. And: The LISA orbits ensure a stable thermal environment, minimising thermal disturbances on the spacecraft.',
              },
              {
                title: 'What are LISA´s key features?',
                image: 'dragfree.png',
                text: 'Key features of LISA are interferometric measurement of distances, million-km long baselines, drag free spacecraft based on inertial sensors, and the familiar “cartwheel”-orbits. Unique are the free-falling test masses inside each spacecraft. The test masses will be undisturbed by forces other than gravitation. A new technology, the so-called “drag-free” operation, allows the spacecraft to follow the test masses, all the while shielding the test masses from spurious forces.',
              }
            ]
          },
          {
            title: 'Technical details',
            cat: 'LISA Technology',
            pages: [
              {
                title: 'What is LISA´s payload?',
                image: 'gwdifferent.jpg',
                text: 'LISA´s payload consists of two identical units on each spacecraft. Each unit contains a Gravitational Reference Sensor (GRS) with an embedded free-falling test mass that acts both as end point of the optical length measurement and as geodesic reference test particle. A telescope transmits the laser light along the arm and also receives the weak light (few hundred pico-Watts!) from the other end. Laser interferometry is performed on an optical bench in between the telescope and the GRS.',
              },
              {
                title: 'What are the test masses made of?',
                image: 'spacevsground.jpg',
                text: 'The test masses are 46 mm cubes, made from a dense non-magnetic Au-Pt alloy and shielded by the Gravitational Reference Sensor (GRS). The GRS core is a housing of electrodes, at several mm separation from the test mass, used for precision capacitive sensing and electrostatic force actuation in all non-interferometric degrees of freedom. The GRS also includes fibers for UV light injection for photoeletric discharge of the test mass and a caging mechanism for protecting the test mass during launch and then releasing it in orbit. The GRS technology is a direct heritage from LISA Pathfinder.',
              },
              {
                title: 'How do the spacecraft remain centred on the test masses?',
                text: 'The spacecraft are actively controlled to remain centred on the test masses along the interferometric axes, without applying forces on the test masses on these axes. To establish this “drag-free operation”, a housing around the test mass senses the relative position of test mass and spacecraft, and a control system commands the spacecraft’s thrusters to follow the free-falling mass.',
              }
            ]
          },
          {
            title: 'Mind-boggling precision',
            cat: 'LISA Technology',
            pages: [
              {
                title: 'How can LISA measure the distance between its spacecraft?',
                image: 'how.jpg',
                text: 'LISA\'s distance measuring system is a continuous interferometric laser ranging scheme, similar to systems used for radar-tracking of spacecraft. But for LISA, the direct reflection of laser light, such as in a normal Michelson interferometer, is not feasible due to the large distance of million km between the spacecraft: Diffraction expands the laser beam so much that for each Watt of laserpower sent, only about 250 pW are received. Direct reflection would thus result in an attenuation factor of about 6.25 x 10-20, yielding about one photon in every three days. ',
              },
              {
                title: 'How is it being met?',
                text: 'LISA´s lasers at the end of each arm operate in a “transponder” mode: A laser beam is sent out from one spacecraft to another. The laser in the far spacecraft is then phase-locked to the incoming beam thus returning a high-power phase replica. The returned beam is received by the initial spacecraft and its phase in turn compared with the phase of the local laser. The same scheme is employed in all three arms, resulting in a total of 6 transponder links (2 per arm).',
              },
              {
                title: 'Another unique feature',
                text: 'Another unique feature',
              }
            ]
          },
        ],
        data: [
          {
            title: 'Overlapping signals',
            cat: 'LISA Data Analysis',
            pages: [
              {
                title: 'How can we extract science from the data?',
                image: 'laserbeam.jpg',
                text: 'Key components of LISA´s data analysis are the ability of creating high-fidelity waveforms for gravitational wave sources, having a well-understood signal simulator for the mission, and being able to extract the source parameters from the simulated signals. In so-called Mock LISA Data Challenges (MLDC) scientists already demonstrated the feasibility of LISA data analysis.',
              },
              {
                title: 'What are Mock LISA Data Challenges (MLDC)',
                image: 'concept.jpg',
                text: 'MLDCs are based on blind challenges of increasing complexity – from a few sources in the first challenge to the full combination of all likely sources in the data stream in the most recent fourth challenge. Scientific research groups from all over the world developed, tested and implemented a wide variety of techniques. As a result a proof-of-concept for LISA data analysis is strongly tested and ready to go.',
              },
              {
                title: 'Will LISA data be publicly available?',
                image: 'dragfree.png',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              }
            ]
          },
          {
            title: 'Infrastructure and public data',
            cat: 'LISA Data Analysis',
            pages: [
              {
                title: 'The Data Processing Centre DPC',
                image: 'gwdifferent.jpg',
                text: 'During the 5 years of the survey, LISA will collect and process terabytes of data using thousands of CPUs. The DPC (Data Processing Centre) will provide the hardware and software infrastructure and means to store and process those data.',
              },
              {
                title: 'What are data analysis pipelines?',
                image: 'spacevsground.jpg',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
              },
              {
                title: 'How are the scientific products being delivered?',
                text: 'In strong interaction with the Data Analysis Groups of the LISA Consortium, the DPC will implement, execute and control the data analysis pipelines and deliver the scientific products (such as catalogues of identified gravitational waves) to the consortium. To do so, it\'s main focus will be on developing tools to support: software development, test and validation; pipeline integration and deployment on computing infrastructures; data management, tracing and archiving; simulation activities.',
              }
            ]
          },

        ],
        boxes: [
          {
            title: '',
            pages: [
              {
                title: 'Mission',
                text: 'LISA is a space-borne Gravitational Wave Observatory with an arm-length of 2.5 million km, compared to the few km\'s of the ground-based observatories. LISA will enable us to discover the parts of the universe that are invisible by other means, such as black holes, the Big Bang, and other, as yet unknown, objects. LISA will enhance our knowledge about the beginning, evolution and structure of our universe.',
                image: 'thefirst.jpg',
                link: 'mission',
                credits: 'AEI/MildeMarketing'
              }
            ]
          },
          {
            title: '',
            pages: [
              {
                title: 'Science',
                text: 'Gravitational waves are ripples in the fabric of space-time generated by some of the most powerful astrophysical events - such as exploding stars and collisions of two black holes at the centres of galaxies. Gravitational waves travel at the speed of light through the universe, unhindered by intervening mass - to gravitational waves the universe is transparent. That is why gravitational waves are the cosmic messengers that allow us to explore the so far dark side of the universe.',
                image: 'science.jpg',
                link: 'mission',
                credits: 'ESA/NASA, AVO project, Paolo Padovani'
              }
            ]
          },
          {
            title: '',
            pages: [
              {
                title: 'Tech',
                text: 'A suitable instrument for measuring gravitational waves over a broad band of low frequencies is a laser interferometer with an arm length as large as possible and long integration times, the primary impetus for a space-borne detector. Hence LISA can be thought of basically as a high precision Michelson interferometer in space with an arm length of 2.5 million km. The arm length has been carefully chosen to allow observation of most of the interesting sources of gravitational waves.',
                image: 'technology.png',
                link: 'mission',
                credits: 'AEI/MildeMarketing'
              }
            ]
          }
        ]
      }
    },
    methods: {
      gotoLISA () {
        this.autoScroll = true
        this.$vuetify.goTo('#lisa',{offset:-22})
        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)
      },
      gotoMission () {
        this.autoScroll = true
        this.$vuetify.goTo('#mission',{offset:-34})
        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)
      },
      gotoScience () {
        this.autoScroll = true
        this.$vuetify.goTo('#science',{offset:-34})
        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)
      },
      gotoTech () {
        this.autoScroll = true
        this.$vuetify.goTo('#tech',{offset:-34})
        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)
      },
      gotoData () {
        this.autoScroll = true
        this.$vuetify.goTo('#data',{offset:-34})
        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)
      },
      openSettings () {
        this.$router.push(this.$router.currentRoute.path + '#settings')
      },
      scrollToAnchor () {



        if (this.$router.currentRoute.hash === ('#lisa')) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#lisa', { offset: -22 })
          })
        } else if (this.$router.currentRoute.hash === ('#mission')) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#mission', { offset: -34 })
          })
        } else if (this.$router.currentRoute.hash === ('#science')) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#science', { offset: -34 })
          })
        } else if (this.$router.currentRoute.hash === ('#tech')) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#tech', { offset: -34 })
          })
        }  else if (this.$router.currentRoute.hash === ('#data')) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#data', { offset: -34 })
          })
        }

        var self = this
        setTimeout(function(){
          self.autoScroll = false
        }, 500)

      },
      handleScroll (event) {



        this.elementTop = document.getElementById('midNav').offsetTop
        this.elementMission = document.getElementById('mission').offsetTop
        this.elementTech = document.getElementById('tech').offsetTop
        this.elementData = document.getElementById('data').offsetTop
        this.elementScience = document.getElementById('science').offsetTop
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop



        //handle menu position (auto hash change)

        if (this.autoScroll === false) {

          if (this.scrollTop <= 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#start')) {this.$router.push(this.$router.currentRoute.path + '#start')}
            })
          } else if (this.scrollTop >= this.elementData - 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#data')) {this.$router.push(this.$router.currentRoute.path + '#data')}
            })
          } else if (this.scrollTop >= this.elementTech - 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#tech')) {this.$router.push(this.$router.currentRoute.path + '#tech')}
            })
          } else if (this.scrollTop >= this.elementScience - 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#science')) {this.$router.push(this.$router.currentRoute.path + '#science')}
            })
          } else if (this.scrollTop >= this.elementMission - 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#mission')) {this.$router.push(this.$router.currentRoute.path + '#mission')}
            })
          } else if (this.scrollTop >= this.elementTop - 42) {

            this.$nextTick(() => {
              this.autoChange = true
              if (this.$router.currentRoute.hash !== ('#lisa')) {this.$router.push(this.$router.currentRoute.path + '#lisa')}
            })
          }

          var self = this
          setTimeout(function(){
            self.autoChange = false
          }, 500)

        }




        if (this.scrollTop >= this.elementTop + 96) {
          this.scrolled = true
        } else {
          this.scrolled = false
        }
        // set max width of home menu
        this.maxWidth = (this.scrollTop / this.elementTop)
        if (this.maxWidth > 1) {
          this.maxWidth = 1
        }
        this.thisFont = (this.scrollTop / this.elementTop) * 14
        if (this.thisFont > 14) {
          this.thisFont = 14
        }
        if (this.thisWidth > 0) {
          this.thisWidth = this.thisWidth + '%'
        }
        this.thisPadding = (this.scrollTop / this.elementTop) * 16
        if (this.thisPadding > 16) {
          this.thisPadding = 16
        }
        this.thisOpacity = (this.scrollTop / this.elementTop) * 10 - 9
        if (this.thisOpacity > 1) {
          this.thisOpacity = 1
        }
        if (this.thisOpacity < 0) {
          this.thisOpacity = 0
        }
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    watch: {
      '$route': function () {
        // this.scrollToAnchor()
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    mounted () {

      let self = this
      setTimeout(function(){
        self.handleScroll()
        self.$nextTick(() => {
          self.$vuetify.goTo(0)
          self.scrollToAnchor()
        })
      }, 500)



    }
  }
</script>
<style>

  .lineclamp{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .fixMe {
    position: fixed;
    top:0;
    right:0;
    left:0;
    z-index:20 !important;
    /* background-color: rgba(0,0,0,1) !important; */
  }

  #midNav .v-toolbar__extension {
    height: 32px !important;
  }

</style>
